/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { Plugins, Context, Config } from '@leverege/plugin';
import { Selection } from '@leverege/ui-redux';
import { Content } from '@leverege/ui-elements';
import { Toolbar } from '@leverege/ui-plugin';
import NoDataView from "../views/NoDataView.js";
import TablePagination from "../table/TablePagination.js";
import ListView from "./ListView.js";
import useListSelection from "./hooks/useListSelection.js";
import S from './MobileListView.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function MobileListView(props) {
  const {
    paginator,
    dispatch,
    rolloverKey,
    selected,
    selectionKey,
    objectType,
    relationship: {
      path
    },
    delegate
  } = props;
  const onClick = ({
    data
  }) => {
    if (delegate.isGotoAllowed()) {
      dispatch(delegate.goTo(data.id));
    } else {
      const flt = Context.createMatch({
        mobile: true,
        objectType,
        path
      });
      const plgs = [...Plugins.get('listClick', flt),
      // backwards compatibility
      ...Plugins.get('ListDataViewerClick', flt)];
      for (let n = 0; n < plgs.length; n++) {
        if (plgs[n].onClick(data, props)) {
          return;
        }
      }
    }
  };
  const options = {
    idKey: 'id'
  };
  const selector = useListSelection({
    dispatch,
    selected,
    selectionKey,
    options
  });
  const onOver = data => {
    dispatch(Selection.set(rolloverKey, {
      id: data.id,
      type: objectType
    }));
  };
  const onOut = () => {
    dispatch(Selection.clear(rolloverKey));
  };
  const actionBarMatchContext = {
    use: 'actionBar',
    client: MobileListView.CLIENT,
    objectType,
    path,
    mobile: true,
    isMobile: true
  };
  const filterBarMatchContext = {
    use: 'filterBar',
    client: MobileListView.CLIENT,
    objectType,
    path,
    mobile: true,
    isMobile: true
  };
  const footerMatchContext = {
    client: MobileListView.CLIENT,
    objectType,
    path,
    mobile: true,
    isMobile: true
  };
  const context = {
    client: MobileListView.CLIENT,
    clientProps: props,
    isMobile: true
  };
  let noDataMessage = Config.get(MobileListView.CLIENT, 'noDataMessage', NoDataView);
  if (noDataMessage != null && typeof noDataMessage !== 'string') {
    // assume its a component class/function
    const Clazz = noDataMessage;
    noDataMessage = /*#__PURE__*/_jsx(Clazz, {
      ...props,
      client: MobileListView.CLIENT
    });
  }
  return /*#__PURE__*/_jsxs(Content, {
    variant: "mobileListContainer|listContainer",
    children: [/*#__PURE__*/_jsxs(Content.Header, {
      variant: "mobileListToolbar|listToolbar|tableToolbar",
      layout: "flex:mobileListToolbar|listToolbar|tableToolbar",
      children: [/*#__PURE__*/_jsx(Toolbar, {
        className: S.toolbar,
        variant: "mobileFilterBar|mobileActionBar|filterBar|actionBar",
        matchContext: filterBarMatchContext,
        context: context
      }), /*#__PURE__*/_jsx(Toolbar, {
        className: S.toolbar,
        variant: "mobileActionBar|actionBar",
        prefer: "icon",
        matchContext: actionBarMatchContext,
        context: context
      })]
    }), /*#__PURE__*/_jsxs(Content.Area, {
      variant: "mobileList|list",
      layout: "flex:mobileList|list|col",
      className: S.list,
      children: [/*#__PURE__*/_jsx(ListView, {
        ...props,
        context: context,
        items: paginator.pageItems,
        onClick: onClick,
        onOver: onOver,
        onOut: onOut,
        selector: selector,
        noDataMessage: noDataMessage
      }), /*#__PURE__*/_jsx(TablePagination, {
        variant: "mobileListPagination|listPagination",
        footerClassName: S.footer,
        context: context,
        matchContext: footerMatchContext,
        paginator: paginator
      })]
    })]
  });
}
MobileListView.CLIENT = 'ListDataViewer';
export default connect((state, props) => {
  const {
    selectionKey,
    rolloverKey,
    loading,
    paginator
  } = props;
  return {
    selected: Selection.get(state, selectionKey),
    rollover: Selection.get(state, rolloverKey),
    loading: loading && paginator.pageItems.length === 0
  };
})(MobileListView);